/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { useQuery } from 'react-query';
import type {
    InvalidateOptions,
    QueryClient,
    QueryFunction,
    QueryKey,
    UseQueryOptions,
    UseQueryResult,
} from 'react-query';

import { customFetchInstance } from '../../../../../../orval/client/custom-fetch';
import { getCustomQueryOptions } from '../../../../../../orval/mutator/custom-query-options';
import { PaginatedAccountFeatureFlagListList } from '../../models';
import type {
    AccountFeatureFlagDropdown,
    ApiAccountFeatureFlagsDropdownListParams,
    ApiAccountFeatureFlagsListParams,
} from '../../models';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K,
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key !== 'queryKey') {
            Object.defineProperty(result, key, {
                enumerable: true,
                configurable: true,
                get: () => (query as Record<string, unknown>)[key],
            });
        }
    }
    return result;
};

export const getApiAccountFeatureFlagsListUrl = (
    params?: ApiAccountFeatureFlagsListParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(
                key,
                value === null ? 'null' : String(value),
            );
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `${process.env.ORVAL_API_BASE_URL}/api/account-feature-flags/?${stringifiedParams}`
        : `${process.env.ORVAL_API_BASE_URL}/api/account-feature-flags/`;
};

export const apiAccountFeatureFlagsList = async (
    params?: ApiAccountFeatureFlagsListParams,
    options?: RequestInit,
): Promise<PaginatedAccountFeatureFlagListList> => {
    return customFetchInstance<PaginatedAccountFeatureFlagListList>(
        getApiAccountFeatureFlagsListUrl(params),
        {
            credentials: 'same-origin',
            ...options,
            method: 'GET',
        },
    );
};

export const getApiAccountFeatureFlagsListQueryKey = (
    params?: ApiAccountFeatureFlagsListParams,
) => {
    return ['apiAccountFeatureFlagsList', ...(params ? [params] : [])] as const;
};

export const useApiAccountFeatureFlagsListQueryOptions = <
    TData = Awaited<ReturnType<typeof apiAccountFeatureFlagsList>>,
    TError = unknown,
>(
    params?: ApiAccountFeatureFlagsListParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiAccountFeatureFlagsList>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getApiAccountFeatureFlagsListQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof apiAccountFeatureFlagsList>>
    > = ({ signal }) =>
        apiAccountFeatureFlagsList(params, { signal, ...requestOptions });

    const customOptions = getCustomQueryOptions({
        queryKey,
        queryFn,
        ...queryOptions,
    });

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<typeof apiAccountFeatureFlagsList>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type ApiAccountFeatureFlagsListQueryResult = NonNullable<
    Awaited<ReturnType<typeof apiAccountFeatureFlagsList>>
>;
export type ApiAccountFeatureFlagsListQueryError = unknown;

export function useApiAccountFeatureFlagsList<
    TData = Awaited<ReturnType<typeof apiAccountFeatureFlagsList>>,
    TError = unknown,
>(
    params?: ApiAccountFeatureFlagsListParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiAccountFeatureFlagsList>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useApiAccountFeatureFlagsListQueryOptions(
        params,
        options,
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const invalidateApiAccountFeatureFlagsList = async (
    queryClient: QueryClient,
    params?: ApiAccountFeatureFlagsListParams,
    options?: InvalidateOptions,
): Promise<QueryClient> => {
    await queryClient.invalidateQueries(
        {
            queryKey: getCustomQueryOptions({
                queryKey: getApiAccountFeatureFlagsListQueryKey(params),
            }).queryKey,
        },
        options,
    );

    return queryClient;
};

export const getApiAccountFeatureFlagsDropdownListUrl = (
    params?: ApiAccountFeatureFlagsDropdownListParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(
                key,
                value === null ? 'null' : String(value),
            );
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `${process.env.ORVAL_API_BASE_URL}/api/account-feature-flags/dropdown/?${stringifiedParams}`
        : `${process.env.ORVAL_API_BASE_URL}/api/account-feature-flags/dropdown/`;
};

export const apiAccountFeatureFlagsDropdownList = async (
    params?: ApiAccountFeatureFlagsDropdownListParams,
    options?: RequestInit,
): Promise<AccountFeatureFlagDropdown[]> => {
    return customFetchInstance<AccountFeatureFlagDropdown[]>(
        getApiAccountFeatureFlagsDropdownListUrl(params),
        {
            credentials: 'same-origin',
            ...options,
            method: 'GET',
        },
    );
};

export const getApiAccountFeatureFlagsDropdownListQueryKey = (
    params?: ApiAccountFeatureFlagsDropdownListParams,
) => {
    return [
        'apiAccountFeatureFlagsDropdownList',
        ...(params ? [params] : []),
    ] as const;
};

export const useApiAccountFeatureFlagsDropdownListQueryOptions = <
    TData = Awaited<ReturnType<typeof apiAccountFeatureFlagsDropdownList>>,
    TError = unknown,
>(
    params?: ApiAccountFeatureFlagsDropdownListParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiAccountFeatureFlagsDropdownList>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getApiAccountFeatureFlagsDropdownListQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof apiAccountFeatureFlagsDropdownList>>
    > = ({ signal }) =>
        apiAccountFeatureFlagsDropdownList(params, {
            signal,
            ...requestOptions,
        });

    const customOptions = getCustomQueryOptions({
        queryKey,
        queryFn,
        ...queryOptions,
    });

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<typeof apiAccountFeatureFlagsDropdownList>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type ApiAccountFeatureFlagsDropdownListQueryResult = NonNullable<
    Awaited<ReturnType<typeof apiAccountFeatureFlagsDropdownList>>
>;
export type ApiAccountFeatureFlagsDropdownListQueryError = unknown;

export function useApiAccountFeatureFlagsDropdownList<
    TData = Awaited<ReturnType<typeof apiAccountFeatureFlagsDropdownList>>,
    TError = unknown,
>(
    params?: ApiAccountFeatureFlagsDropdownListParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiAccountFeatureFlagsDropdownList>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useApiAccountFeatureFlagsDropdownListQueryOptions(
        params,
        options,
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const invalidateApiAccountFeatureFlagsDropdownList = async (
    queryClient: QueryClient,
    params?: ApiAccountFeatureFlagsDropdownListParams,
    options?: InvalidateOptions,
): Promise<QueryClient> => {
    await queryClient.invalidateQueries(
        {
            queryKey: getCustomQueryOptions({
                queryKey: getApiAccountFeatureFlagsDropdownListQueryKey(params),
            }).queryKey,
        },
        options,
    );

    return queryClient;
};
